import { createContext } from 'react'

import AccountStore from '../store/AccountStore'
import AnalyticsViewGraphsStore from '../store/AnalyticsViewGraphsStore'
import ApplicationStore from '../store/ApplicationStore'
import ContactStore from '../store/ContactStore'
import CustomObjectStore from '../store/CustomObjectStore'
import DealActivitiesStore from '../store/DealActivitiesStore'
import DealStore from '../store/DealStore'
import DealTasksStore from '../store/DealTasksStore'
import FieldsStore from '../store/FieldsStore'
import FilterSetStore from '../store/FilterSetStore/FilterSetStore'
import FilterSetStoreV1 from '../store/FilterSetStoreV1/FilterSetStoreV1'
import PipelineStore from '../store/PipelineStore'
import StageStore from '../store/StageStore'
import UserStore from '../store/UserStore'
import {
   ActivityTemplatesStore,
   ApplicationTemplateStore,
   ContactTemplatesStore,
   CustomObjectTemplateStore,
   DealTemplatesStore,
   LeadTemplatesStore,
   PipelineEventTemplateStore,
   TaskTemplatesStore,
   UserPropertiesTemplateStore
} from '../types'

import type ActivityStore from '../store/ActivityStore'
import type BoardStore from '../store/BoardStore'
import type LeadActivitiesStore from '../store/LeadActivitiesStore'
import type LeadStore from '../store/LeadStore'
import type LeadTasksStore from '../store/LeadTasksStore'
import type EntityRemarksStore from '../store/EntityRemarksStore'
import type TaskStore from '../store/TaskStore'
import type AnalyticsGraphsStore from '../store/AnalyticsGraphsStore'
export const LeadStoreContext = createContext<LeadStore | null>(null)

export const CustomObjectStoreContext = createContext<CustomObjectStore | null>(
   null
)

export const ApplicationStoreContext = createContext<ApplicationStore | null>(
   null
)

export const DealStoreContext = createContext<DealStore | null>(null)

export const ContactStoreContext = createContext<ContactStore | null>(null)

export const ActivityStoreContext = createContext<ActivityStore | null>(null)

export const AnalyticsGraphsStoreContext = createContext<AnalyticsGraphsStore | null>(
   null
)

export const AnalyticsViewGraphsStoreContext = createContext<AnalyticsViewGraphsStore | null>(
   null
)

export const EntityRemarksStoreContext = createContext<EntityRemarksStore | null>(
   null
)

export const TaskStoreContext = createContext<TaskStore | null>(null)

export const LeadActivitiesStoreContext = createContext<LeadActivitiesStore | null>(
   null
)

export const DealActivitiesStoreContext = createContext<DealActivitiesStore | null>(
   null
)

export const LeadTasksStoreContext = createContext<LeadTasksStore | null>(null)

export const DealTasksStoreContext = createContext<DealTasksStore | null>(null)

export const ActivityTemplatesStoreContext = createContext<ActivityTemplatesStore | null>(
   null
)
export const TaskTemplatesStoreContext = createContext<TaskTemplatesStore | null>(
   null
)

export const LeadTemplatesStoreContext = createContext<LeadTemplatesStore | null>(
   null
)

export const CustomObjectTemplateStoreContext = createContext<CustomObjectTemplateStore | null>(
   null
)

export const ApplicationTemplateStoreContext = createContext<ApplicationTemplateStore | null>(
   null
)

export const DealTemplatesStoreContext = createContext<DealTemplatesStore | null>(
   null
)

export const FieldsStoreContext = createContext<FieldsStore | null>(null)

export const BoardStoreContext = createContext<BoardStore | null>(null)

export const ContactTemplateStoreContext = createContext<ContactTemplatesStore | null>(
   null
)
export const PipelineEventTemplateStoreContext = createContext<PipelineEventTemplateStore | null>(
   null
)

export const UserPropertiesTemplateStoreContext = createContext<UserPropertiesTemplateStore | null>(
   null
)
export const PipelineStoreContext = createContext<PipelineStore | null>(null)

export const FilterSetStoreContext = createContext<FilterSetStore | null>(null)
export const FilterSetStoreV1Context = createContext<FilterSetStoreV1 | null>(
   null
)
export const UserStoreContext = createContext<UserStore | null>(null)
export const StageStoreContext = createContext<StageStore | null>(null)

export const AccountStoreContext = createContext<AccountStore | null>(null)
